// removed by extract-text-webpack-plugin
module.exports = {"container":"manage-categories__container___2S7I4","controls-container":"manage-categories__controls-container___3CgoQ","grid-container":"manage-categories__grid-container___2nP8p","bottom-grid":"manage-categories__bottom-grid___2ud2s","top-grid":"manage-categories__top-grid___3vCYl"};


//////////////////
// WEBPACK FOOTER
// ./src/scss/components/manage-categories/manage-categories.scss
// module id = 517
// module chunks = 0